<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header style="padding:2rem 1rem 0rem 1rem;">
      <div>已选物资：{{form.piece}}</div>
    </zj-layout-header>
    <zj-layout-main style="padding:1rem 1rem;">
      <zj-layout-container>
        <zj-layout-main style="padding:0px 0px;">
          <el-table :data="gridData" height="100%" max-height="27rem" style="min-height:27rem;">
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column property="MaterialName" label="物资名称"></el-table-column>
            <el-table-column
              property="MaterialTypeId"
              label="物资类型"
              :formatter="ConvertMaterialType"
              align="center"
            ></el-table-column>
            <el-table-column property="StockNum" label="现库存" align="center"></el-table-column>
          </el-table>
        </zj-layout-main>
        <zj-layout-footer style="padding:1rem 0px;">
          <el-divider></el-divider>
          <el-form :model="form" ref="form" class="zj-search-form" label-width="8rem" style="margin-top:4rem;" :rules="rules">
            <el-form-item label="出库数量" style="display:inline-block;">
              <el-input-number
                style="width:50rem;"
                v-model="form.num"
                autocomplete="off"
                :min="1"
                :max="MaxStockNum"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="领取人" style="display:inline-block;" prop="person">
              <el-input style="width:50rem;" v-model="form.person" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="领取日期" style="display:inline-block;">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="form.OutDate"
                style="width:50rem;"
                :clearable="false"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </zj-layout-footer>
      </zj-layout-container>
    </zj-layout-main>
    <zj-layout-footer style="text-align:center;">
      <el-button @click="onBack()">取消</el-button>
      <el-button @click="submitForm()">确定</el-button>
    </zj-layout-footer>
  </zj-layout-container>
</template>

<script>
import ZJApp from '../../../../../app';
import MyApis from "../../../apis";
const utils = ZJApp.ZJUtils;
export default {
  data() {
    return {
      loading: true,
      loadingText: '加载中',
      gridData: [],
      form: {
        piece: "（共0条）",
        num: 1,
        OutDate: new Date(),
        person:""
      },
      MaterialTypeDic: [],
      MaxStockNum: 1,
       rules: {
        person: [
          { required: true, message: "请输入领取人", trigger: "blur" }
        ]
      }
    };
  },
  props: {
    viewData2: Object,
    materialTypedate2: Object
  },
  created: function() {
    this.basedatabind();

    var selectData = this.viewData2;
    this.form.piece = "（共" + selectData.length + "条）";

    this.gridData = selectData;

    this.form.person = this.user.DisplayName;
    this.MaxStockNum = selectData[0].StockNum;
    for (var i = 0; i < selectData.length; i++) {
      var item = selectData[i];
      if (this.MaxStockNum > item.StockNum) {
        this.MaxStockNum = item.StockNum;
      }
    }
    if (this.MaxStockNum == 0) {
      this.form.num = 0;
    }
  },
  mounted: function() {
    //console.log(this.viewData2);
  },
  methods: {
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    //取消按钮
    onBack() {
      //this.dialogTableVisible = false;
      this.$emit("cancel", {});
    },
     submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.save();
        } else {
          console.error("error submit!!");
          return false;
        }
      });
    },
    //确定按钮
    save() {
      const datalist = this.viewData2;
      datalist.forEach(item => {
        item.IsInOut = false;
        item.InOutNum = parseInt(this.form.num);
        item.Recipients = this.form.person;
        item.PickupDate = this.form.OutDate;
      });
      this.loading = true;
      this.loadingText = '保存中...';
      new MyApis.MaterialsApi()
        .InOutStock(datalist)
        .then(r => {
          r = r.data.Data;
          if (r) {
            this.$message({
              type: "success",
              message: "出库成功!"
            });
          } else {
            this.$message({
              type: "error",
              message: "出库失败!"
            });
          }
          this.logInfo.ActionName = "应急物资出库";
          this.logInfo.LogMessage = r ? "应急物资出库成功" : "应急物资出库失败";
          this.logInfo.ModuleName = "应急系统";
          this.logInfo.PageName = "应急物资管理";
          this.addOperationLog();
          this.$emit("search", {});
          this.$emit("ok", {});
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });

    },
    //基础数据绑定
    basedatabind() {

      this.loading = true;
      this.loadingText = '加载中...';

      utils.waitAll([
        this.config.getUValue("EmergencyService:MaterialType:", "")
      ])
      .then(r => {

        //物资类型
        let d = r[0];
        for (var i = 0; i < d.JValue.length; i++) {
          var item = d.JValue[i];
          this.MaterialTypeDic[item.ItemKey] = item.Extend1;
        }

        this.loading = false;
      })
      .catch(e => {
        console.error(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        this.loading = false;
      });
    },
    ConvertMaterialType(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let levelstr = this.materialTypedate2[data];
      return levelstr;
    }
  }
};
</script>
<style lang="scss" scoped>
.zj-layout-container .zj-layout-main .zj-table-container {
  margin-top: 0.8rem;
  margin-bottom: 1rem;
  flex: 1 1 auto;
  overflow: auto;
  overflow-x:hidden;
  max-height: 30rem;
}
</style>